import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { LockListPage } from "@/features/expansion-locks/LockListPage"

const searchSchema = z.object({
	/** lock to scroll to and highlight */
	lock: z.string().optional().catch(undefined),
})

export const Route = createFileRoute("/catalogue/games/$gameSlug_/locks")({
	component: GameLocksPage,
	validateSearch: searchSchema,
})

function GameLocksPage() {
	const { gameSlug } = Route.useParams()
	const { lock } = Route.useSearch()
	return <LockListPage gameSlug={gameSlug} focusLockId={lock} />
}
